import EventBus from 'dashboard/components/GraphCanvasV2/event-bus';
import GraphEvent from 'dashboard/components/GraphCanvasV2/events/graph-event';
import G6Wrapper from 'dashboard/components/GraphCanvasV2/G6Wrapper';
import { GraphExplorer } from 'dashboard/models/graph-explorer';

/* eslint-disable @typescript-eslint/ban-ts-comment, no-console */
// @ts-ignore
window.DEBUG_BEHAVIOR_HANDLER_CALLS = false;
/* eslint-enable @typescript-eslint/ban-ts-comment, no-console */

export default abstract class Behavior {
  constructor(
    protected g6Wrapper: G6Wrapper,
    protected graphExplorer: GraphExplorer,
    protected eventBus: EventBus,
  ) {}
  abstract get events(): Record<string, string>;
  abstract reactivate(): void;
  abstract reset(): void;
  public respondsToEvent(e: GraphEvent<Event>) {
    return Object.prototype.hasOwnProperty.call(this.events, e.type);
  }
  public callHandler(e: GraphEvent<Event>) {
    const handlerName = this.events[e.type];
    const handler = (this as unknown as Record<string, (e: GraphEvent<Event>) => void>)[
      handlerName
    ];

    /* eslint-disable @typescript-eslint/ban-ts-comment, no-console */
    // @ts-ignore
    if (window.DEBUG_BEHAVIOR_HANDLER_CALLS) {
      console.debug(`Calling ${this.constructor.name}.${handlerName}`);
    }
    /* eslint-enable @typescript-eslint/ban-ts-comment, no-console */
    return handler.call(this, e);
  }
  protected get graph() {
    return this.g6Wrapper.graph;
  }
}
